module.exports = __webpack_public_path__ + "static/media/bell.72101879.svg";